var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app tw-bg-[#f1f5f9] dark:tw-bg-[#101623] tw-w-full"},[_c('Alert'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }